import { useCallback, useEffect, useRef, useState } from "react";
import InkLevels from "./InkLevels/InkLevels";
import SectionHeader from "../SectionHeader/SectionHeader";
import sparkleWandIcon from "../../../../assets/images/BrotherPlus/wand-magic-sparkles-icon.svg";
import inkDrop from "../../../../assets/images/BrotherPlus/inkDrop.svg";
import warningIcon from "../../../../assets/images/BrotherPlus/warning_circle.svg";
import EasyBuy from "./EasyBuy/EasyBuy";
import EasyBuySummary from "./EasyBuySummary/EasyBuySummary";
import upArrow from "../../../../assets/images/upArrow.svg";
import downArrow from "../../../../assets/images/downArrow.svg";
import './EasyBuyComponent.css';
import { useTranslation } from "react-i18next";
import { getInkColorListTranslation } from "../../../../constants/AppMethod";
import convertHtmlToReact from "@hedgedoc/html-to-react";
import React, { memo } from "react";
import EasyBuySummaryMobileView from "./EasyBuySummary/EasyBuySummaryMobileView";
import Loader from "../../../../components/shared/loader/Loader";
import { getEasyBuyRequest } from "../../../../store/EasyBuy/EasyBuySlice";
import { useDispatch, useSelector } from "react-redux";

const EasyBuyComponent = memo((props) => {
    const { isApplyBPlusNewDeviceDiscount = false, defaultExpanded = false, easyBuyRef, scrollOnMount = false, onEasyBuyScrolled } = props;
    const containerRef = useRef(null);
    const [easyBuySummaryData, setEasyBuySummaryData] = useState([]);
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);
    const [lowInkList, setLowInkList] = useState([]);
    const [lowInkReplaced, setLowInkReplaced] = useState([]);
    const { t } = useTranslation(["translation"]);
    const dispatch = useDispatch();
    const newDevicePromoCodeResponse = useSelector((state => state.BROTHERPLUS.getNewDevicePromoCode));

    const scrollOnMountRef = useCallback((node) => {
        if (node) {
            containerRef.current = node;
            if (easyBuyRef) easyBuyRef.current = node;
            if (scrollOnMount) {
                node.scrollIntoView({ behavior: 'smooth' });
                onEasyBuyScrolled?.();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (lowInkList?.length) {
            setIsExpanded(true);
        }
    }, [lowInkList])

    useEffect(() => {
        dispatch(getEasyBuyRequest({ isApplyBPlusNewDeviceDiscount }));
    }, [isApplyBPlusNewDeviceDiscount, dispatch]);

    const { loading, error } = useSelector(
        (state) => state.ROOTREDUCER_RTK.EasyBuy
    );

    if (loading || (isApplyBPlusNewDeviceDiscount && newDevicePromoCodeResponse.loading)) return <Loader />

    return (
        <>
            <SectionHeader imageSrc={sparkleWandIcon} title={t("INK_LEVELS.TITLE")}  />
            <InkLevels {...props} lowInkList={lowInkList} setLowInkList={setLowInkList} isBPlusUpgradedEcoPro = {false} setLowInkReplaced={setLowInkReplaced} lowInkReplaced={lowInkReplaced}/>
            <div className="easy-buy-container" ref={scrollOnMountRef}>
                <>
                    <div className="saveAndOrder">
                        <div className="save-ink-drop-text">
                            <img src={inkDrop} alt="Ink Drop" />
                            <span>{t("EASY_BUY.TITLE")}</span>
                        </div>
                        <div
                            className="order-ink-button"
                            onClick={() => {
                                setIsExpanded(!isExpanded);
                            }}>
                            {t("EASY_BUY.ORDER_INK_BUTTON")} <img src={isExpanded ? upArrow : downArrow} alt='arrow' />
                        </div>
                    </div>
                    {lowInkList && lowInkList?.length > 0 &&
                        <div className="warning-ink-level">
                            <img src={warningIcon} alt='warningIcon' />
                            <span> {convertHtmlToReact(t("EASY_BUY.LOW_INK_WARNING", { "lowInks": `${getInkColorListTranslation(lowInkList)}` }))} </span>
                        </div>}
                </>
                {error && <div>{t("EASY_BUY.ERROR_MESSAGE")}</div>}
                {!error && isExpanded &&
                    <div id="easybuy-section" className="easy-buy-content-wrapper">
                        <EasyBuy isApplyBPlusNewDeviceDiscount={isApplyBPlusNewDeviceDiscount} setEasyBuySummaryData={setEasyBuySummaryData} easyBuySummaryData={easyBuySummaryData} lowInkList={lowInkList} lowInkReplaced={lowInkReplaced} />
                        <EasyBuySummary isApplyBPlusNewDeviceDiscount={isApplyBPlusNewDeviceDiscount} easyBuySummaryData={easyBuySummaryData} setEasyBuySummaryData={setEasyBuySummaryData} />
                        <EasyBuySummaryMobileView isApplyBPlusNewDeviceDiscount={isApplyBPlusNewDeviceDiscount} easyBuySummaryData={easyBuySummaryData} setEasyBuySummaryData={setEasyBuySummaryData}></EasyBuySummaryMobileView>
                    </div>
                }
            </div>
        </>
    )
})

export default EasyBuyComponent;